import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-messages-shader',
  templateUrl: './messages-shader.component.html',
  styleUrls: ['./messages-shader.component.scss']
})
export class MessagesShaderComponent extends BaseComponent implements OnInit {
  @Input()
  isErrorMessage = false;
  @Input()
  messageImages: { image: string; imageFlip: string } = {
    image: '/assets/Images/Login/StudentKey.png',
    imageFlip: '/assets/Images/Login/StudentKeyFlip.png'
  };
  @Input()
  messages: { header: string; details: string } = {
    header: 'Common.PasswordRequestHeader',
    details: 'Common.PasswordRequestDetails'
  };
  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    if (this.isErrorMessage) {
      this.messageImages = {
        image: '/assets/Images/Login/Robot.png',
        imageFlip: '/assets/Images/Login/RobotFlip.png'
      };
      this.messages = {
        header: 'Common.ErrorHeader',
        details: 'Common.ErrorDetails'
      };
    }
  }
  goToLogin(): void {
    this.router.navigate(['Login']);
  }
  goToContactSupport(): void {
    this.router.navigate(['Login']);
  }
  changeLanguage(): void {
    if (this.translateService.currentLang === 'en') {
      this.settings.rtl = true;
      this.translateService.use('ar');
      localStorage.setItem('lang', 'ar');
    } else {
      this.settings.rtl = false;
      this.translateService.use('en');
      localStorage.setItem('lang', 'en');
    }
  }
}
